import React from 'react';
import { Trans } from '@lingui/macro';

import Card from '@rover/components/src/cards/Card';
import { Flex, Heading } from '@rover/kibble/core';
import type { HomepageRebookingProfile } from '@rover/rsdk/src/apiClient/latest/model/homepageRebookingProfile';

import RebookingItems from './RebookingItems';

export type Props = {
  sitters: HomepageRebookingProfile[];
  language?: string;
};

const RebookingProfiles = ({ language, sitters = [] }: Props): JSX.Element => (
  <Card marginRight="4x">
    <Flex width="100%" flexDirection="column">
      <Heading size="300">
        <Trans>Rebook a previous sitter</Trans>
      </Heading>
      <RebookingItems language={language} sitters={sitters} />
    </Flex>
  </Card>
);

export default RebookingProfiles;
